import styled from 'styled-components'
import { device } from 'Styled/variables'

export const CloseButton = styled.img`
  position: absolute;
  padding: 10px;
  width: 35px;
  height: 35px;
  top: 45.5px;
  right: 44.5px;
  cursor: pointer;

  @media ${device.mobileMax} {
    width: 40px;
    height: 40px;
    top: 22px;
    right: 22px;
  }
`
